import { render } from "./InformacionLaboralClienteRegular.vue?vue&type=template&id=72d6eb01&scoped=true"
import script from "./InformacionLaboralClienteRegular.vue?vue&type=script&lang=js"
export * from "./InformacionLaboralClienteRegular.vue?vue&type=script&lang=js"

import "./InformacionLaboralClienteRegular.vue?vue&type=style&index=0&id=72d6eb01&scoped=true&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72d6eb01"]])

export default __exports__